import { Link } from 'react-router-dom';
import type { ContentItem } from '@/utils/content';
import { getCategoryName, formatHot } from '@/utils/content';

interface MovieCardProps {
  item: ContentItem;
}

export default function MovieCard({ item }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors duration-200 cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-primary-900">
        <img
          src={item.cover}
          alt={`${item.title}中文字幕在线观看`}
          title={`${item.title} - 中文字幕在线观看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-primary-950/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
          <span className="w-12 h-12 rounded-full bg-accent-500 text-background-50 flex items-center justify-center">
            <i className="ri-play-fill text-2xl"></i>
          </span>
        </div>
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md text-xs font-medium bg-primary-800/90 text-background-50 whitespace-nowrap">
          {getCategoryName(item.category)}
        </span>
        <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md text-xs font-semibold bg-accent-500 text-background-50 whitespace-nowrap">
          {item.rating.toFixed(1)}
        </span>
      </div>
      <div className="p-3">
        <h3 className="text-sm md:text-base font-semibold text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
          {item.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-600 truncate">
          {item.year} · {item.region} · {item.quality}
        </p>
        <div className="mt-2 flex items-center justify-between gap-2">
          <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs bg-secondary-100 text-secondary-900 whitespace-nowrap">
            <i className="ri-translate-2"></i>
            {item.subtitle}
          </span>
          <span className="text-xs text-foreground-500 whitespace-nowrap">{formatHot(item.hot)}</span>
        </div>
      </div>
    </Link>
  );
}